import PropTypes from 'prop-types';
import React from 'react';

import Modal from 'shared/Modal';
import Button from 'shared/Button';
import CarrierForms from 'shared/CarrierForms';
import Field from 'shared/Field';
import Input from 'shared/Input';

import { FontSizes, FontWeights } from 'constants/Clementine';

import FormsEngineApi from 'utils/FormsEngineApi';
import FormUtils from 'utils/Form';

class EmailFormsModal extends React.Component {
  static propTypes = {
    formData: PropTypes.object,
    forms: PropTypes.array,
    onClose: PropTypes.func,
    selectedForms: PropTypes.array
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      current_view: 'review',
      selected_forms: null,
      forms_download_request: null,
      errors: [],

      phone_number: '',
      message: 'Here is a link to the documents you requested.'
    };
  }

  _handleInputChange = (name, e) => {
    this.setState({
      [name]: e.target.value
    });
  };

  _handleFormClick = selected_forms => {
    this.setState({
      selected_forms
    });
  };

  _toggleView = current_view => {
    this.setState({ current_view });
  };

  _generatePdf = () => {
    const { phone_number, message, selected_forms } = this.state;
    const errors = [];

    if (!FormUtils._validatePhone(phone_number)) {
      errors.push('phone_number');
    }

    if (!message.length) {
      errors.push('message');
    }

    if (errors.length) {
      this.setState({
        errors
      });
    } else {
      this.setState({
        loading: true
      });

      FormsEngineApi.generatePdf(
        Object.assign({}, this.props.formData, {
          form_guids: selected_forms || this.props.selectedForms,
          pdf_action: 'text',
          phone_number,
          message
        })
      ).then(forms_download_request => {
        this.setState({
          current_view: 'success',
          forms_download_request,
          loading: false,
          errors: []
        });
      });
    }
  };

  _openPdf = () => {
    window.open(this.state.forms_download_request.pdf_url);
  };

  render() {
    const { forms, onClose, selectedForms } = this.props;
    const { current_view, selected_forms, loading, errors, phone_number, message } = this.state;
    const styles = this.styles();
    const filtered_forms = forms.filter(f => selectedForms.includes(f.guid));
    const titles = {
      review: 'Text: Review Forms',
      info: 'Text: Recipient Information',
      success: ''
    };
    const buttons = {
      review: [
        {
          color: '#e5e5e5',
          fontColor: '#999',
          onClick: onClose,
          style: { margin: '0 10px 0 auto' },
          children: 'Cancel'
        },
        {
          onClick: this._toggleView.bind(null, 'info'),
          children: 'Next'
        }
      ],
      info: [
        {
          color: '#e5e5e5',
          fontColor: '#999',
          onClick: this._toggleView.bind(null, 'review'),
          style: { margin: '0 10px 0 auto' },
          children: 'Back'
        },
        {
          onClick: this._generatePdf.bind(null, 'info'),
          children: 'Send Text'
        }
      ]
    };

    return (
      <Modal buttons={buttons[current_view]} loading={loading} maxWidth={800} onClose={onClose} title={titles[current_view]}>
        {current_view === 'review' ? (
          <div style={styles.content}>
            <div style={styles.review_wrapper}>
              <CarrierForms forms={filtered_forms} layout='list' onFormClick={this._handleFormClick} selectedForms={selected_forms || selectedForms} />
            </div>
          </div>
        ) : null}

        {current_view === 'info' ? (
          <div style={styles.content}>
            <Field label='Phone Number'>
              <Input format='phone' invalid={errors.includes('phone_number')} onChange={this._handleInputChange.bind(null, 'phone_number')} required={true} value={phone_number} />
            </Field>
            <Field label='Message'>
              <Input invalid={errors.includes('message')} onChange={this._handleInputChange.bind(null, 'message')} required={true} style={{ height: 195 }} type='textarea' value={message} />
            </Field>
          </div>
        ) : null}

        {current_view === 'success' ? (
          <div style={styles.content}>
            <div style={styles.success_wrapper}>
              <div style={styles.success_title}>Success!</div>
              <div style={styles.success_description}>
                The selected forms have been combined into a single PDF and a link has been texted to <span style={{ fontWeight: FontWeights.MEDIUM }}>{FormUtils._formatAsPhone(phone_number)}</span>.
                Click the button below to view the PDF and download it for your own records.
              </div>
              <Button inline={true} onClick={this._openPdf}>
                View Combined PDF
              </Button>
            </div>
          </div>
        ) : null}
      </Modal>
    );
  }

  styles = () => {
    return {
      content: {
        padding: 40,
        width: 800
      },
      review_wrapper: {
        borderTop: '1px solid #e5e5e5',
        borderLeft: '1px solid #e5e5e5',
        borderRadius: 4,
        overflow: 'hidden',
        marginBottom: -1
      },
      success_wrapper: {
        textAlign: 'center',
        width: '60%',
        margin: '0 auto'
      },
      success_title: {
        fontSize: FontSizes.XLARGE,
        fontWeight: FontWeights.MEDIUM,
        marginBottom: 20
      },
      success_description: {
        fontSize: FontSizes.MEDIUM,
        color: '#777',
        marginBottom: 40,
        lineHeight: '1.5em'
      }
    };
  };
}

export default EmailFormsModal;
